package com.milta.feature.auth.domain.entity

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
enum class UserRole(val apiValue: String) {
    @SerialName("Driver") DRIVER("Driver"),
    @SerialName("Enterprise") ENTERPRISE("Enterprise"),
    // Eonix-internal, cross-tenant platform role — never self-registrable, web-only (see Main.kt).
    @SerialName("Admin") ADMIN("Admin"),
}
